import { ReactNode, useEffect } from "react";
import {
  Invitation,
  Organization,
  Program,
} from "@platform/types/platform.types";
import {
  ONBOARDING_MOUNT,
  useOnboardingDispatch,
} from "../../OnboardingContext";

type Props = {
  children: ReactNode;
  invitation: Invitation;
  organization: Organization;
  program: Program;
};

export function OnboardingContainer({
  children,
  invitation,
  organization,
  program,
}: Props) {
  const dispatch = useOnboardingDispatch();

  useEffect(() => {
    dispatch({
      type: ONBOARDING_MOUNT,
      payload: { invitation, organization, program },
    });
  }, [dispatch, invitation, organization, program]);

  return <>{children}</>;
}

export default OnboardingContainer;
